module.exports = "//d274d294w9cx2v.cloudfront.net/1938ab09805506bba3527620c1aab0fd4d98848a/images/payPalBadge.png";